import React from 'react';
import { BlockLayoutProps } from 'ui-builder';

import styles from './BaseBlockLayout.module.scss';

export default function BaseBlockLayout(props: BlockLayoutProps) {
  return (
    <div
      className={[
        props.className,
        props.isContentDisabled ? styles.contentDisabled : ''
      ].join(' ')}
      onClick={props.onClick}
      style={props.backgroundColor ? { backgroundColor: props.backgroundColor } : {}}
      title={props.title}
      data-testid={props.testID}
    >
      {props.children}
    </div>
  );
}

export function FormBlockLayout(props: BlockLayoutProps) {

  const classes = [
    props.className || '',
    'form-rows'
  ];
  return (
    <BaseBlockLayout
      className={classes.join(' ')}
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      title={props.title}
      testID={props.testID}
    >
      {props.children}
    </BaseBlockLayout>
  );
}
